import {
  CHAVES_GERENCIAMENTO_USUARIOS,
  CHAVES_ROTA_APURACOES,
  CHAVES_ROTA_AUTOMACOES,
  CHAVES_ROTA_CONTA_CORRENTE,
  CHAVES_ROTA_EMPRESAS,
  CHAVES_ROTA_FINANCEIRO,
  CHAVES_ROTA_GRUPOS_ACESSO,
  CHAVES_ROTA_GRUPOS_ECONOMICOS,
  CHAVES_ROTA_ICMS,
  CHAVES_ROTA_IMPORTACOES,
  CHAVES_ROTA_INSS,
  CHAVES_ROTA_JURIDICO,
  CHAVES_ROTA_PARAMETRIZACOES,
  CHAVES_ROTA_PARCEIROS,
  CHAVES_ROTA_PIS_COFINS,
  CHAVES_ROTA_PROCESSAMENTO,
  CHAVES_ROTA_PROJETOS_APURACAO,
  CHAVES_ROTA_RELATORIOS,
  CHAVES_ROTA_VINCULOS,
  CHAVES_ROTA_WORKFLOW,
} from "../config/Context/PermissoesContext";

const REGRAS_HREF = [
  // Cadastros
  {
    match: (h) => (h || "").startsWith("/cadastros/usuarios") || (h || "").startsWith("/acessos/usuarios"),
    anyOf: CHAVES_GERENCIAMENTO_USUARIOS,
  },
  {
    match: (h) => (h || "").startsWith("/acessos/grupos-usuarios") || (h || "").startsWith("/cadastros/grupos-usuarios"),
    anyOf: CHAVES_ROTA_GRUPOS_ACESSO,
  },
  {
    match: (h) =>
      (h || "").startsWith("/cadastros/grupos-economicos") ||
      (h || "").startsWith("/cadastros/empresas/grupos-economicos") ||
      (h || "").startsWith("/empresas/grupos-economicos"),
    anyOf: CHAVES_ROTA_GRUPOS_ECONOMICOS,
  },
  {
    match: (h) => (h || "").startsWith("/acessos/parceiros-associados"),
    anyOf: CHAVES_ROTA_PARCEIROS,
  },
  {
    match: (h) => (h || "").startsWith("/cadastros/empresas") || (h || "").startsWith("/empresas"),
    anyOf: CHAVES_ROTA_EMPRESAS,
  },
  // E-Social / INSS
  {
    match: (h) => (h || "").startsWith("/esocial/previas") || (h || "").startsWith("/esocial/projetos"),
    anyOf: CHAVES_ROTA_INSS,
  },
  {
    match: (h) => (h || "").startsWith("/inss") && !(h || "").startsWith("/conta-corrente"),
    anyOf: CHAVES_ROTA_INSS,
  },
  // PIS/COFINS
  { match: (h) => (h || "").startsWith("/piscofins"), anyOf: CHAVES_ROTA_PIS_COFINS },
  // Importações
  { match: (h) => (h || "").startsWith("/importacoes/importadores"), anyOf: CHAVES_ROTA_IMPORTACOES },
  { match: (h) => (h || "").startsWith("/importacoes/automacoes"), anyOf: CHAVES_ROTA_AUTOMACOES },
  // Conta Corrente (mais específico primeiro: Projetos tem permissão própria, TXM-558)
  {
    match: (h) => (h || "").startsWith("/conta-corrente/projetos"),
    anyOf: CHAVES_ROTA_PROJETOS_APURACAO,
  },
  { match: (h) => (h || "").startsWith("/conta-corrente"), anyOf: CHAVES_ROTA_CONTA_CORRENTE },
  // Financeiro
  { match: (h) => (h || "").startsWith("/financeiro"), anyOf: CHAVES_ROTA_FINANCEIRO },
  // Jurídico
  { match: (h) => (h || "").startsWith("/juridico"), anyOf: CHAVES_ROTA_JURIDICO },
  // ICMS
  { match: (h) => (h || "").startsWith("/icms"), anyOf: CHAVES_ROTA_ICMS },
  // Relatórios (mais específico primeiro)
  { match: (h) => (h || "").startsWith("/relatorios/apuracoes"), anyOf: CHAVES_ROTA_APURACOES },
  { match: (h) => (h || "").startsWith("/relatorios/processamento"), anyOf: CHAVES_ROTA_PROCESSAMENTO },
  { match: (h) => (h || "").startsWith("/relatorios"), anyOf: CHAVES_ROTA_RELATORIOS },
  // Vínculos
  { match: (h) => (h || "").startsWith("/vinculos"), anyOf: CHAVES_ROTA_VINCULOS },
  // Workflow
  { match: (h) => (h || "").startsWith("/workflow"), anyOf: CHAVES_ROTA_WORKFLOW },
  // Parametrizações
  { match: (h) => (h || "").startsWith("/parametrizacoes"), anyOf: CHAVES_ROTA_PARAMETRIZACOES },
];

function submenuPermitido(sub, podeFn) {
  const href = sub?.href || "";
  for (const r of REGRAS_HREF) {
    if (r.match(href)) return podeFn(r.anyOf);
  }
  return true;
}

/**
 * Remove itens de submenu e pais sem filhos após filtro (TXM-216).
 * @param {Array} items — itens do menu (estrutura itensMenu)
 * @param {function(string[]): boolean} podeFn — retorno de usePermissoes().pode
 * @param {boolean} aplicar — se false, retorna cópia rasa sem filtrar
 */
export function filtrarMenuPorPermissoes(items, podeFn, aplicar = true) {
  if (!aplicar || !Array.isArray(items)) return Array.isArray(items) ? [...items] : [];
  return items
    .map((item) => {
      const rawSubs = Array.isArray(item.submenu) ? item.submenu : [];
      const subs = rawSubs.filter((sub) => submenuPermitido(sub, podeFn));
      const tinhaSubs = rawSubs.length > 0;
      return { ...item, submenu: subs, _tinhaSubs: tinhaSubs };
    })
    .filter((item) => !(item._tinhaSubs && item.submenu.length === 0))
    .map(({ _tinhaSubs, ...rest }) => rest);
}
